<div class="header">
  <h1>{{title}}</h1>
  <p>November 28<sup>st</sup> 2019 Vašulka Kitchen Brno</p>
  <small>Marina Abramovič po sebe neupratuje + Performance Studio</small>
</div>

<ngx-slider
  [type]="'video'"
  [playlist]="playlist"
></ngx-slider>

<app-datatata
  [text]="datatataText"
  [theme]="'light'"
></app-datatata>